import { useQuery } from "react-query";
import { fetchData } from "../api/client";

/**
 * Retorna { company, scopes: string[] } de /me/permissions
 * Revalida automaticamente quando a "Company" do header mudar.
 */
export function useEffectivePermissions() {
  // Dica: se você guarda a empresa ativa em sessionStorage, use-a como parte da queryKey
  const companyHeader =
    sessionStorage.getItem("activeCompany") || // id ou slug
    sessionStorage.getItem("selectedCompany") || null;

  return useQuery(
    ["me-permissions", companyHeader],
    async () => {
      const res = await fetchData(`/me/permissions`, "GET");
      const data = res?.data || res || {};
      return {
        company: data.company ?? null,
        scopes: Array.isArray(data.scopes) ? data.scopes : [],
      };
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 10 * 60 * 1000,
    }
  );
}

/** Recurso e ação da permissão para Emitir BPe (passagens rodoviárias). Alinhado ao catálogo da API (bpe.view). */
export const BPE_PERMISSION_RESOURCE = "bpe";
export const BPE_PERMISSION_ACTION = "view";
export const BPE_SCOPE = `${BPE_PERMISSION_RESOURCE}.${BPE_PERMISSION_ACTION}`;

/** Helpers */
export const toSet = (arr) => new Set(Array.isArray(arr) ? arr : []);
export const hasScope = (set, scope) => set.has(scope);
export const can = (set, resource, action = "view") => set.has(`${resource}.${action}`);
export const canAny = (set, pairs = []) =>
  pairs.some(([resource, action = "view"]) => set.has(`${resource}.${action}`));

/** Verifica se o usuário tem permissão para usar a funcionalidade de Emitir BPe no Chat. */
export const canEmitirBPe = (set) => can(set, BPE_PERMISSION_RESOURCE, BPE_PERMISSION_ACTION);
